import api from "@/services/api";

import { TransactionType } from "@/types/transaction/Transaction";
class GetTransactions {
  execute = async (
    franchiseId?: string,
    associateId?: string,
    startDate?: String | undefined,
    endDate?: String | undefined
  ) => {
    const sanitizedAssociateId = associateId?.trim() ? associateId : undefined;
    const sanitizedFranchiseId = franchiseId?.trim() ? franchiseId : undefined;
    const transactions = await api().get("/transactions", {
      params: {
        franchiseId: sanitizedFranchiseId,
        associateId: sanitizedAssociateId,
        startDate: startDate,
        endDate: endDate,
      },
    });
    return transactions.data as TransactionType[];
  };
}

export { GetTransactions };
